"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var validUrl = /^https?:\/\//i;

var _default = function _default(options) {
  if (!validUrl.test(options.url)) {
    throw new Error("\"".concat(options.url, "\" is not a valid URL"));
  }
};

exports.default = _default;
module.exports = exports.default;
//# sourceMappingURL=defaultOptionsValidator.js.map